import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import CategoryHero from './components/CategoryHero';
import CategoryGrid from './components/CategoryGrid';
import DeepFeature from './components/DeepFeature';
import { buildWebPageSchema, buildBreadcrumbSchema } from '@/mocks/schema';
import { mockCategories } from '@/mocks/articles';

const categoryOrder = ['star-scandal', 'influencer-gossip', 'black-material'] as const;

const categoryNames: Record<string, string> = {
  'star-scandal': '明星爆料',
  'influencer-gossip': '网红吃瓜',
  'black-material': '黑料入口',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) return null;

  const category = mockCategories[slug as keyof typeof mockCategories];
  const name = categoryNames[slug] || slug;

  const webPageSchema = buildWebPageSchema({
    title: `${name} - 51吃瓜每日大赛`,
    description: `51吃瓜每日大赛${name}专栏，${category?.description || '最新娱乐爆料与八卦资讯'}`,
    url: `http://dingzhishi.cn/category/${slug}`,
    dateModified: '2026-07-07',
  });

  const breadcrumbSchema = buildBreadcrumbSchema([
    { name: '首页', url: 'http://dingzhishi.cn/' },
    { name: name, url: `http://dingzhishi.cn/category/${slug}` },
  ]);

  return (
    <>
      <SchemaOrg data={webPageSchema} />
      <SchemaOrg data={breadcrumbSchema} />
      <Navbar />
      <main>
        <nav className="w-full px-4 md:px-8 pt-20" aria-label="Breadcrumb">
          <div className="max-w-[1280px] mx-auto flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </span>
            <span className="text-foreground-700 whitespace-nowrap">{name}</span>
          </div>
        </nav>
        <CategoryHero categorySlug={slug} />

        {/* Category Tab Switcher */}
        <div className="w-full px-4 md:px-8 pb-6 bg-background-50">
          <div className="max-w-[1280px] mx-auto flex flex-wrap gap-2">
            {categoryOrder.map((catSlug) => (
              <Link
                key={catSlug}
                to={`/category/${catSlug}`}
                className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  catSlug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200 hover:text-foreground-900'
                }`}
              >
                {categoryNames[catSlug]}
              </Link>
            ))}
          </div>
        </div>

        <CategoryGrid categorySlug={slug} />
        <DeepFeature />
      </main>
      <Footer />
    </>
  );
}